import apiClient from '../lib/apiClient';

export const getPropertiesApi  = ()        => apiClient('/host/properties/my-properties');
export const createPropertyApi = (payload) => apiClient('/host/properties/add', { method: 'POST', body: payload });

// Used during onboarding — authenticates with setup_token instead of the regular JWT
export const setupPropertyApi  = (payload, setupToken) =>
  apiClient('/host/properties/add', {
    method:  'POST',
    body:    payload,
    headers: { Authorization: `Bearer ${setupToken}` },
  });
